/**
 * components/layout/scrollButtons.js — Дэлгэцийг дээш/доош гүйлгэх хөвөгч товч.
 *
 * Layout дотор нэг л удаа mount хийгддэг тул вэбийн БҮХ хуудсанд харагдана.
 * Урт жагсаалт дээр курсорыг гүйлгэх шаардлагагүйгээр нэг товшилтоор
 * хуудасны эхэнд / төгсгөлд очно.
 *
 *   ▲ — хамгийн дээш
 *   ▼ — хамгийн доош
 *
 * Товч нь хуудас гүйлгэх боломжтой (агуулга дэлгэцээс урт) үед л гарч ирнэ.
 * Дээд/доод захад хүрсэн үед тухайн товч бүдгэрч, идэвхгүй болно.
 */
import React, { useCallback, useEffect, useState } from "react";

const ERDENET_GREEN = "#0F6E56";

// Захад хүрсэн гэж үзэх зөвшөөрөгдөх зөрүү (px)
const EDGE = 24;

export default function ScrollButtons() {
  const [scrollable, setScrollable] = useState(false);
  const [atTop, setAtTop] = useState(true);
  const [atBottom, setAtBottom] = useState(false);

  const measure = useCallback(() => {
    const el = document.scrollingElement || document.documentElement;
    if (!el) return;
    const max = el.scrollHeight - el.clientHeight;
    setScrollable(max > EDGE * 2);
    setAtTop(el.scrollTop <= EDGE);
    setAtBottom(el.scrollTop >= max - EDGE);
  }, []);

  useEffect(() => {
    measure();
    window.addEventListener("scroll", measure, { passive: true });
    window.addEventListener("resize", measure);

    // Хуудас солигдох / дата ачаалагдахад агуулгын өндөр өөрчлөгдөнө —
    // ResizeObserver-оор дахин хэмжинэ.
    let ro;
    if (typeof ResizeObserver !== "undefined" && document.body) {
      ro = new ResizeObserver(measure);
      ro.observe(document.body);
    }
    return () => {
      window.removeEventListener("scroll", measure);
      window.removeEventListener("resize", measure);
      if (ro) ro.disconnect();
    };
  }, [measure]);

  const scrollTo = (where) => {
    const el = document.scrollingElement || document.documentElement;
    if (!el) return;
    window.scrollTo({
      top: where === "top" ? 0 : el.scrollHeight,
      behavior: "smooth",
    });
  };

  if (!scrollable) return null;

  const btn = (disabled) => ({
    width: 38,
    height: 38,
    borderRadius: "50%",
    border: "1px solid " + (disabled ? "#E3E6EA" : ERDENET_GREEN + "55"),
    background: disabled ? "#F5F6F7" : "#fff",
    color: disabled ? "#C9CCD1" : ERDENET_GREEN,
    boxShadow: disabled ? "none" : "0 2px 10px rgba(15,110,86,0.18)",
    cursor: disabled ? "default" : "pointer",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 14,
    padding: 0,
    transition: "all .15s",
  });

  return (
    <div
      style={{
        position: "fixed",
        right: 16,
        bottom: 20,
        zIndex: 1000,
        display: "flex",
        flexDirection: "column",
        gap: 8,
      }}
    >
      <button
        type="button"
        title="Хамгийн дээш (Home)"
        aria-label="Хамгийн дээш"
        disabled={atTop}
        onClick={() => scrollTo("top")}
        style={btn(atTop)}
      >
        <i className="fas fa-chevron-up" />
      </button>
      <button
        type="button"
        title="Хамгийн доош (End)"
        aria-label="Хамгийн доош"
        disabled={atBottom}
        onClick={() => scrollTo("bottom")}
        style={btn(atBottom)}
      >
        <i className="fas fa-chevron-down" />
      </button>
    </div>
  );
}
